import createReducer from 'reducers/createReducer';

import { Qna } from 'actions/actionTypes';

import { ArrayConcat } from 'utils/functions';

const INITIAL_STATE = { 
    searchFilter: {
        page: 1,
        pageSize: 10,
        qnaTypeCode: [],
    },
    qnaList: {
        maxPage: 0,
        totalCount: 0,
        list: []
    },
    question:{
        qnaTypeCode: '',
        title: '',
        content: '',
        attachments1: null,
        attachments2: null,
        attachments3: null,
        attachments4: null,
        attachments5: null,
    },
    qnaInfo: {
        idx: 0,
        qnaType: '',
        questionTitle: '',
        questionContent: '',
        qnaStatus: '',
        questionRegTime: '',
        cdn: '',
        attachmentsList: [],
        answerList: [],
    },
    error: {
        triggered: false,
        message: '',
    },
};

// 리듀서
const reducer = createReducer(INITIAL_STATE, {
    // 이벤트
    [Qna.CHANGE_SEARCH_FILTER]: (state, action) => {
        if(action.payload.type === 'checkbox') {
            state.searchFilter[action.payload.name] = ArrayConcat(Array.from(state.searchFilter[action.payload.name]), action.payload.value);
        }
        else {
            state.searchFilter[action.payload.name] = action.payload.value;
        }
    },
    [Qna.CHANGE_QUESTION]: (state, action) => {
        state.question[action.payload.name] = action.payload.value;
    },
    [Qna.ADD_QUESTION]: (state, action) => {
        state.question = INITIAL_STATE.question;
    },

    // 검색 필터 초기화
    [Qna.SEARCH_QNA_FILTER_RESET]: (state, action) => {
        state.searchFilter = INITIAL_STATE.searchFilter;
    },

    // 문의 목록 조회
    [Qna.LOAD_QNA_LIST_REQUEST]: (state, action) => {
        state.error = INITIAL_STATE.error;
    },
    [Qna.LOAD_QNA_LIST_SUCCESS]: (state, action) => {
        state.searchFilter.page = action.payload.currentPage;
        state.qnaList.maxPage = action.payload.maxPage;
        state.qnaList.totalCount = action.payload.totalCount;
        state.qnaList.list = action.payload.list;
    },
    [Qna.LOAD_QNA_LIST_FAILURE]: (state, action) => {
        state.error = {
            triggered: true,
            message: action.payload,
        };
    },

    // 문의 등록
    [Qna.ADD_QNA_QUESTION_REQUEST]: (state, action) => {
        state.error = INITIAL_STATE.error;
    },
    [Qna.ADD_QNA_QUESTION_SUCCESS]: (state, action) => {
    },
    [Qna.ADD_QNA_QUESTION_FAILURE]: (state, action) => {
        state.error = {
            triggered: true,
            message: action.payload,
        };
    },

    // 문의 상세 조회
    [Qna.LOAD_QNA_INFO_REQUEST]: (state, action) => {
        state.error = INITIAL_STATE.error;
        state.qnaInfo.idx = action.payload.idx;
    },
    [Qna.LOAD_QNA_INFO_SUCCESS]: (state, action) => {
        state.qnaInfo = {
            idx: action.payload.idx,
            qnaType: action.payload.qnaType,
            questionTitle: action.payload.questionTitle,
            questionContent: action.payload.questionContent,
            qnaStatus: action.payload.qnaStatus,
            questionRegTime: action.payload.questionRegTime,
            cdn: action.payload.cdn,
            attachmentsList: action.payload.attachmentsList,
            answerList: action.payload.answerList,
        };
    },
    [Qna.LOAD_QNA_INFO_FAILURE]: (state, action) => {
        state.error = {
            triggered: true,
            message: action.payload,
        };
    },
});


export default reducer;